import { render, staticRenderFns } from "./garden4.vue?vue&type=template&id=114f3642&"
import script from "./garden4.vue?vue&type=script&lang=js&"
export * from "./garden4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports